import { logError } from '@hotjar/webapp/lib/logger';

export function stripDomain(url: string): string {
  try {
    const u = new URL(url);
    return `${u.pathname}${u.search}${u.hash}`;
  } catch (err) {
    // @ts-expect-error fix catch error type
    logError(err);
    return '';
  }
}

export function stripProtocol(url: string): string {
  try {
    const u = new URL(url);
    return `${u.host}${u.pathname}${u.search}${u.hash}`;
  } catch (err) {
    // @ts-expect-error fix catch error type
    logError(err);
    return '';
  }
}

/**
 * parseUri 1.2.2
 * (c) Steven Levithan <stevenlevithan.com>
 * MIT License
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseUri = (str: string): { [key: string]: any } => {
  const o = {
    strictMode: false,
    key: [
      'source',
      'protocol',
      'authority',
      'userInfo',
      'user',
      'password',
      'host',
      'port',
      'relative',
      'path',
      'directory',
      'file',
      'query',
      'anchor',
    ],
    q: {
      name: 'queryKey',
      parser: /(?:^|&)([^&=]*)=?([^&]*)/g,
    },
    parser: {
      strict:
        // eslint-disable-next-line max-len, no-useless-escape
        /^(?:([^:\/?#]+):)?(?:\/{2,}((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
      loose:
        // eslint-disable-next-line max-len, no-useless-escape
        /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/{2,})?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
    },
  };
  const m = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const uri: { [key: string]: any } = {};
  let i = 14;

  // eslint-disable-next-line no-plusplus
  while (i--) uri[o.key[i]] = m?.[i] || '';

  uri[o.q.name] = {};
  uri[o.key[12]].replace(o.q.parser, ($0: string, $1: string, $2: string) => {
    if ($1) uri[o.q.name][$1] = $2;
  });

  return uri;
};
